import { RANGES, COMPARISON_RANGES } from '@bingads-webui/date-ranges';
import { getSelectionDateRangePreset, grains } from './util/date-range-preset';
import { getSelectionComparisonDateRangeOption } from './util/comparison-date-range-option';
import { getSelectionDateFormatter } from './util/selection-date';

function isRangeNotPreset($daterange) {
  const {
    grain,
    RangeIndex,
  } = $daterange;
  // Only if we have this RangeIndex, we can tell if it is a preset or not.
  if (RangeIndex == null) {
    return false;
  }
  switch (grain) {
    case grains.Today:
    case grains.ThisWeekFromSun:
    case grains.ThisWeekFromMon:
    case grains.LastSevenDays:
    case grains.LastFourteenDays:
    case grains.ThisMonth:
    case grains.LastThirtyDays:
    case grains.AllTime:
      if (RangeIndex === 0) {
        return false; // is preset
      }
      return true;
    case grains.Yesterday:
    case grains.LastWeekStartingSun:
    case grains.LastWeekStartingMon:
    case grains.LastMonth:
      if (RangeIndex === 1) {
        return false; // is preset
      }
      return true;
    default:
      return false;
  }
}

export default function convertStateDateRangeToSelection({
  $daterange,
  i18n,
}) {
  if (!$daterange) {
    return {
      DateRange: null,
      ComparisonDateRange: null,
    };
  }

  const formatAPIDate = getSelectionDateFormatter(i18n);

  const {
    start,
    end,
    key,
    grain,
    compared,
  } = $daterange;

  const startdate = formatAPIDate(start);
  const enddate = formatAPIDate(end);

  // use grain when there is no key, such as in new ui.
  const DateRange = (key === RANGES.CUSTOM || grain === grains.Custom
    || isRangeNotPreset($daterange)) ?
    {
      StartDate: startdate,
      EndDate: enddate,
    } : {
      DateRangePreset: getSelectionDateRangePreset(key, grain),
    };

  if (!compared) {
    return {
      DateRange,
      ComparisonDateRange: null,
    };
  }

  const ComparisonDateRange = compared.key === COMPARISON_RANGES.CUSTOM ? {
    StartDate: formatAPIDate(compared.start),
    EndDate: formatAPIDate(compared.end),
  } : {
    ComparisonDateRangeOption: getSelectionComparisonDateRangeOption(compared.key),
  };

  return {
    DateRange,
    ComparisonDateRange,
  };
}
